// Copy real de duas fontes: Esteira 2026 v3 (seção 3.4, blocos 1 a 9) e o HTML
// de reorganização do time (jul/2026), que revisou pesos, ordem e copy de venda.
// Fonte única: alimenta a página e o JSON-LD. Não editar sem conferir os docs.
// Ajuste jul/2026 (doc Google "mudanças"): o que é / quem conduz / planos /
// amuleto atualizados; "pra quem é" saiu; depoimentos sobem antes da compra.

export const site = {
  name: "Conversas Terapêuticas",
  author: "Manuela Xavier",
  // branch manuela-protagonista: a Manuela assina o produto. O name continua o
  // nome próprio (header, <title>, JSON-LD); a assinatura entra onde o produto
  // se apresenta por extenso (hero, footer, OG, Course).
  assinatura: "por Manuela Xavier",
  headline:
    "Conversas Terapêuticas por Manuela Xavier · psicanálise para atravessar os dilemas da vida feminina",
  sub: "estudos e encontros entre mulheres para atravessar os dilemas da vida feminina juntas",
  selo: "Não é terapia, mas é terapêutico.",
  conceito: "Estudos da Vida Feminina · Turma de 2026",
  description:
    "Um percurso online de estudos sobre os dilemas da vida feminina e encontros entre mulheres, conduzido por Manuela Xavier. Ao longo de quatro ciclos trimestrais, vamos estudar relacionamentos, corpo, trabalho e a relação consigo mesma. Não é terapia, mas é terapêutico.",
};

// O que é — doc de ajustes jul/2026 (antes vivia misturado em "quem conduz")
export const oQueE = {
  kicker: "O que é",
  lead: "Você aprendeu a dar conta de tudo para se tornar uma mulher independente, livre e dona de si. Mas isso não impediu que você se sentisse exausta ou sozinha.",
  corpo:
    "O Conversas Terapêuticas é um percurso online de estudos sobre os dilemas da vida feminina e encontros entre mulheres, conduzido por Manuela Xavier.",
  // citação em 1ª pessoa que fecha a seção; "destaque" fecha a frase em itálico
  quote: {
    destaque: "E aqui eu não separo as coisas. Psicanálise, literatura, cinema, música, arte e o olhar de gênero operando ao mesmo tempo sobre a mesma questão; porque nenhuma questão da vida de uma mulher se explica por uma linguagem só.",
  },
};

// Pôster amarelo entre "o que é" e "quem conduz" (doc jul/2026): o selo virou
// seção própria (sem CTA), não um floreio no painel escuro.
export const seloTerapeutico = {
  titulo: "Não é terapia, mas é terapêutico",
  corpo:
    "Ao longo de quatro ciclos trimestrais, vamos estudar relacionamentos, corpo, trabalho e a relação consigo mesma para que você compreenda o que se repete, deixe de transformar todo conflito em culpa individual e possa elaborar, em companhia, novas formas de estar no mundo.",
};

// Quem conduz — bio em 1ª pessoa do doc de ajustes jul/2026.
// PENDENTE(Thiago): nome do livro dela (a copy diz só "meu livro").
// PENDENTE(Thiago): nome do podcast.
export const quemConduz = {
  kicker: "Quem conduz",
  // fora da página desde jul/2026 (ela definiu o texto final da seção sem esta
  // linha). Fica registrado aqui porque o doc de origem sumiu com o repo antigo.
  credenciais:
    "psicanalista · doutora em psicologia · mais de 10 anos de clínica · autora · podcast · coluna na Glamour",
  bio: [
    "Psicanalista e doutora em Psicologia Clínica pela PUC. Foi professora da UFF e atendeu em consultório por mais de uma década. Hoje é colunista da revista Glamour e referência em narrativas femininas. Entusiasta da articulação entre cultura, arte e psicanálise, conduz há mais de cinco anos grupos de mulheres que discutem o universo feminino por essa lente.",
  ],
  etica:
    "Não substituo análise individual. O que faço é conduzir um espaço terapêutico em grupo, com escuta e profundidade.",
  // canto da foto: frase curta (não só o nome) pra ancorar o retrato (jul/2026)
  fotoLegenda: "Escuta e profundidade",
};

export type Trimestre = {
  /** slug interno (key, âncora); o rótulo visível é "Ciclo {numero}" */
  id: string;
  numero: string;
  titulo: string;
  /** só o nome; o "+ live com" fica na UI pra deixar claro que ela é convidada da live */
  convidadas: string;
  /** o mito que o ciclo desmonta — retirado da UI no ajuste jul/2026; fica no
   *  tipo pra não perder a frase se voltar. */
  ensinaram: string;
  /** o que o ciclo estuda (frase completa, começa com "Vamos estudar…") */
  estudo: string;
  meses: { nome: string; data: string; sub: string }[];
};

export const trimestres: Trimestre[] = [
  {
    id: "ciclo-1",
    numero: "1",
    titulo: "Relacionamentos",
    convidadas: "Marcela Ceribelli",
    ensinaram:
      "A gente aprendeu que o problema do relacionamento é sempre o outro, mas acaba sempre esperando ser escolhida por ele.",
    estudo:
      "Vamos estudar o que a gente realmente busca quando procura alguém: amor, validação ou proteção; e o que se repete quando encontramos frustração.",
    meses: [
      { nome: "Como a gente se relaciona com o outro", data: "set/2026", sub: "Os relacionamentos, as projeções e as frustrações." },
      { nome: "Como a gente se relaciona com a gente", data: "out/2026", sub: "Se perder pra se achar, se desconhecer pra se conhecer." },
      { nome: "Como a gente se relaciona com o mundo", data: "nov/2026", sub: "Somos mesmo livres?" },
    ],
  },
  {
    id: "ciclo-2",
    numero: "2",
    titulo: "Corpo e Prazer",
    convidadas: "Lela Brandão",
    ensinaram:
      "A gente aprendeu a odiar o nosso corpo e não é coincidência sempre pedirmos desculpa ou sentirmos culpa quando sentimos prazer.",
    estudo:
      "Vamos estudar um novo encontro com o corpo e com o desejo e descobrir o que acontece quando a gente desobedece.",
    meses: [
      { nome: "Corpo e autoestima", data: "dez/2026", sub: "O corpo que eu tenho, o corpo que me ensinaram a querer." },
      { nome: "Corpo e sexo", data: "jan/2027", sub: "Desejo e subversão." },
      { nome: "O que é prazer?", data: "fev/2027", sub: "Desobediência sem culpa." },
    ],
  },
  {
    id: "ciclo-3",
    numero: "3",
    titulo: "Trabalho e Dinheiro",
    convidadas: "Júlia Ábi-Sâmara",
    ensinaram:
      "A gente aprendeu a servir antes de aprender a querer, e fomos boas em ser eficientes.",
    estudo:
      "Vamos estudar quanto custa ser boazinha, pra onde vai o seu cansaço e por que ambição, pra gente, tem gosto de castigo.",
    meses: [
      { nome: "As mulheres e o servir", data: "mar/2027", sub: "Ser boazinha cobra um preço, e a gente paga sem saber." },
      { nome: "Produzir não é criar", data: "abr/2027", sub: "Produzir o tempo todo, criar quase nunca." },
      { nome: "Ambição é solidão?", data: "mai/2027", sub: "O que nos impede de crescer." },
    ],
  },
  {
    id: "ciclo-4",
    numero: "4",
    // reorganização jul/2026 renomeou o ciclo (na Esteira era "Autossabotagem")
    titulo: "Nós mesmas",
    convidadas: "Gabrielle Medeiros",
    ensinaram:
      "A gente aprendeu a olhar a nossa pior inimiga todo dia no espelho, e chamar autossabotagem de azar.",
    estudo:
      // o travessão é verbatim da fonte da Manuela (print do build antigo)
      "Vamos estudar quem é essa que fala com a sua voz e trabalha contra você; e descobrir como quebrar esse ciclo.",
    meses: [
      { nome: "O inimigo sou eu", data: "jun/2027", sub: "Quando a inimiga mora dentro, pra onde a gente foge?" },
      { nome: "Violências veladas", data: "jul/2027", sub: "não é azar, é método" },
      { nome: "Construindo novas referências", data: "ago/2027", sub: "Não é começar do zero, é começar inteira." },
    ],
  },
];

// branch manuela-protagonista: os encontros ao vivo com a Manu abrem a lista —
// o tempo com ela é o núcleo da oferta, as aulas gravadas vêm em seguida.
export const entregas = [
  {
    marcador: "4",
    titulo: "Aulas gravadas",
    texto: "Pra ver no seu tempo, quantas vezes quiser, inclusive em versão podcast.",
  },
  {
    marcador: "4",
    titulo: "Encontros ao vivo",
    texto:
      "No Zoom, com a Manu, toda quinta-feira, onde você pode falar, ser ouvida e se conectar com outras mulheres. Não pode participar ao vivo? Fica tranquila, fica tudo gravado pra você ver depois!",
  },
  {
    marcador: "+",
    titulo: "Exercícios terapêuticos",
    texto: "Pra ajudar a dar nome e pra levar pra análise aquilo que foi trabalhado na semana.",
  },
];

// Reorganização jul/2026: o anual virou a oferta principal (card grande, selo de
// fundadora); o trimestral virou porta de entrada secundária (card de apoio).
// Inclusos atualizados no doc de ajustes (antes da compra).
export const planos = {
  trimestral: {
    nome: "Trimestral",
    tag: "Trimestral",
    preco: "R$ 229",
    precoTotal: 687,
    detalhe: "/mês",
    resumo: "Acesso ao ciclo vigente: aulas, encontros ao vivo, exercícios e espaço de troca.",
    // compromisso total: a mensalidade sozinha lê como pegadinha, e o número é
    // só a aritmética dos campos acima (229 × 3 = precoTotal), não fato novo
    itens: [
      "12 aulas gravadas",
      "12 encontros semanais ao vivo com a Manu Xavier no Zoom",
      "12 exercícios de elaboração",
      "Live com convidadas",
      "Acesso ao conteúdo por mais um ano após o fim do ciclo",
    ],
    // nota legal dentro do box, abaixo do CTA (doc jul/2026)
    notaLegal:
      "Você pode solicitar o cancelamento da compra em até sete dias corridos, diretamente pela Hotmart, com reembolso integral dos valores pagos. Após esse prazo, as três cobranças mensais serão mantidas.",
    cta: "Prefiro começar por um ciclo",
  },
  anual: {
    nome: "Anual",
    tag: "Anual · Fundadora",
    selo: "Turma fundadora · 2026",
    preco: "R$ 183",
    precoTotal: 2196,
    detalhe: "/mês",
    sub: "20% menos que o trimestral",
    // idem trimestral: 183 × 12 = precoTotal. E a diferença mensal entre os
    // dois planos (229 − 183) posta em reais, que é o que a visitante compara.
    termos: "12 meses de R$ 183, total de R$ 2.196, sem juros.",
    itens: [
      "20% de economia em relação ao plano trimestral",
      "4 ciclos completos",
      "48 aulas gravadas",
      "48 encontros semanais ao vivo com a Manu Xavier no Zoom",
      "48 exercícios de elaboração",
      "Live com convidadas",
      "Encontro presencial em São Paulo no final do último ciclo, em setembro de 2027",
      "Amuleto exclusivo da turma fundadora pra quem comprar até 31/08/2026",
      "1 ano de acesso ao conteúdo após o fim do ciclo completo",
    ],
    notaLegal:
      "Você pode solicitar o cancelamento da compra em até sete dias corridos, diretamente pela Hotmart, com reembolso integral dos valores pagos. Após esse prazo, as doze cobranças mensais serão mantidas.",
    cta: "Quero fazer parte da turma",
  },
};

export const notaAssinatura =
  "O Conversas funciona por assinatura. Você escolhe entre permanecer por um ciclo de três meses ou fazer o percurso anual de doze meses. As mensalidades são cobradas automaticamente no cartão durante o período escolhido.";

// Amuleto — copy atualizado (citação curta + assinatura/cargo)
export const interludio = {
  kicker: "o amuleto da turma fundadora",
  titulo: "Um símbolo da turma fundadora",
  lead:
    "Quem entra como fundadora pelo percurso anual recebe um colar criado por Manuela Xavier: um olho, pra marcar o ano em que você decidiu voltar a olhar pra aquilo que parecia conhecido e enxergar de outro lugar.",
  citacao: "Que ele te lembre de manter sempre os olhos abertos no peito.",
  assinatura: "Manuela Xavier",
  cargo: "criadora do Conversas Terapêuticas",
};

export const janela =
  "A turma atravessa o ano junta. Depois de 14 de setembro, as condições de fundadora fecham pra 2026.";

export const depoimentosSecao = {
  tituloLinha1: "Elas me",
  tituloLinha2: "escrevem",
  subtitulo:
    "Eu não posso te dizer o que o conversas vai fazer por você, mas elas podem",
};
export const depoimentos: { texto: string; quem: string }[] = [
  {
    texto:
      "Aqui nesse grupo foi o lugar que eu me encontrei, aqui é o meu tesão, é a minha praia. Tem sido uma experiência muito potente na minha vida, foi transformador. Tudo que a gente viveu aqui me levou pra muitas coisas que eu tô construindo na minha trajetória. Eu sou uma mulher de quase 50 anos vivendo primeiras vezes de muitas coisas, e isso tem sido libertador.",
    quem: "Cilene Costa",
  },
  {
    texto:
      "Se a proposta desse trabalho com a Manu era atravessar, comigo eu acho que foi bem-sucedida. Numa das nossas atividades a Manu falou sobre se movimentar sem sair do lugar, e aquilo me tocou muito, porque eu moro no mesmo lugar, trabalho no mesmo lugar, como as mesmas comidas, tenho a mesma rotina. Mas eu me movimentei muito internamente. Hoje eu sei ler as coisas. Muito obrigada a todas as meninas por tudo que a gente viveu aqui!",
    quem: "Bruna Rodrigues",
  },
  {
    texto:
      "Já fez um ano que eu tô nessa jornada com a turma da Manu, e esses encontros são tão transformadores. Todas as falas das mulheres foram muito importantes pra mim, foram transformadoras. Eu tô muito feliz com essa comunidade que a gente tem criado. Eu vejo que, de fato, agora eu tô dirigindo a minha vida. Agora eu tô me tornando quem eu quero me tornar.",
    quem: "Jessica Monteiro",
  },
];

export const datas = {
  abertura: "17 ago",
  inicio: "7 set",
  fechamento: "14 set",
  inicioLongo: "7 de setembro",
  fechamentoLongo: "14 de setembro",
  aberturaISO: "2026-08-17",
  inicioISO: "2026-09-07",
  fechamentoISO: "2026-09-14",
};

// FAQ da reorganização jul/2026: 5 perguntas, na ordem da referência. Onde a
// referência dizia "[Resposta atual.]", entra a resposta que já existia.
export const faqs = [
  {
    q: "Substitui terapia?",
    a: "Não. O Conversas não substitui terapia individual nem tratamento. É um percurso terapêutico em grupo, com o olhar da psicanálise. Por isso o selo: não é terapia, mas é terapêutico.",
  },
  {
    q: "Posso cancelar minha assinatura?",
    a: "Você pode cancelar junto a Hotmart até 7 dias após a data da compra.",
  },
  {
    q: "Como funcionam os encontros ao vivo?",
    a: "São quatro lives por mês, às quintas-feiras às 20h no Zoom. Lives são participativas: você pode falar, perguntar, ser ouvida. Quem não consegue estar ao vivo recebe a gravação na plataforma.",
  },
  {
    q: "Fica gravado?",
    a: "Fica. Todas as aulas ficam gravadas na plataforma pra você assistir no seu tempo. As lives também ficam gravadas. Você não perde nada, só não tem a interação ao vivo daquele dia.",
  },
  {
    q: "Posso entrar só por um ciclo?",
    a: "Pode. A modalidade trimestral te dá acesso a um trimestre temático completo. Você decide se continua nos trimestres seguintes na hora.",
  },
];
